module.exports = __webpack_public_path__ + "static/media/logo138x75black.6fe3103c.png";